var exports = {
  "wG": "loader-V1NaY",
  "R": "hidden-V1NaY",
  "SU": "muted-V1NaY",
  "ZH": "play-V1NaY",
  "l1": "l1-V1NaY",
  "l2": "l2-V1NaY",
  "l3": "l3-V1NaY",
  "l4": "l4-V1NaY",
  "l5": "l5-V1NaY",
  "l6": "l6-V1NaY",
  "l7": "l7-V1NaY",
  "l8": "l8-V1NaY",
  "l9": "l9-V1NaY",
  "U6": "pulse-V1NaY",
  "Mz": "wave-V1NaY",
};

module.exports = exports;
